import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/iot-new/strategic_iot.webp";

const Androidbuss = () => {
  return (
    <div
      className="androidbuss tekrevol_dark_bg p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={11}
            lg={10}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Our Strategic Considerations for Building Next-Gen{" "}
              <span>IoT Software Products</span>
            </h2>
            <p>
              The approach to creating new-generation IoT software products
              implies the further use of complex technologies and reliable
              frameworks that will ensure the creation of unique IoT products.
            </p>
            <p>
              This approach is based on using state-of-the-art methodologies,
              minimal impact on the existing systems, and optimized data
              protection and users’ experience. Specifically, our strategic
              approach means IoT products developed by our company correspond to
              the current market needs and potential future trends and
              difficulties
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Scalability and Flexibility</h6>
                <p>
                  We ensure that our IoT software products are developed with
                  the flexibility feature to accommodate increased load and
                  other potential changes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Security and Compliance</h6>
                <p>
                  We follow high standards of security and the provisions of the
                  law, as our strategy involves encryption of information
                  end-to-end with safe authentication.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Edge and Cloud Integration</h6>
                <p>
                  The data processing at the edge reduces latency and bandwidth
                  but is integrated with the cloud for managing, storing, and
                  analyzing all data effectively.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Interoperability and Standards</h6>
                <p>
                  IOT solutions that we offer put the highest emphasis on
                  compatibility by following the standard protocol of respective
                  Industries.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Data Analytics and AI</h6>
                <p>
                  Through leveraging big data and machine learning, we equip our
                  IoT software solutions to be intelligent tools focusing on
                  readable and anticipative information.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>User-Centric Design</h6>
                <p>
                  We focus on providing user-friendly interfaces and this means
                  our IoT software products are easy to use for the
                  end-consumer.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
